import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiResourceCardImage]',
    standalone: false
})
export class ResourceCardImageDirective {
  @HostBinding('class') hostClasses = {
    'resource-card-image': true,
  };
}
